import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-user-project-time',
  templateUrl: './user-project-time.component.html',
  styleUrls: ['./user-project-time.component.css']
})
export class UserProjectTimeComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
  }

}
